import { Navigate } from "react-router-dom";

import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { useTenantSwitcher } from "@/contexts/TenantSwitcherContext";
import { useAuth } from "@/contexts/AuthContext";

interface TenantRequiredRouteProps {
  children: JSX.Element;
}

export function TenantRequiredRoute({
  children,
}: TenantRequiredRouteProps): JSX.Element {
  const { user } = useAuth();
  const { activeTenant, loadingTenant } = useTenantSwitcher();

  if (loadingTenant) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  const isPlatform = user?.platformRole === "root" || user?.platformRole === "root_admin";
  if (isPlatform && !activeTenant) {
    return <Navigate to="/tenants" replace />;
  }

  if (user != null && !isPlatform && !activeTenant) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
